import React, {createContext, useEffect, useReducer, useContext} from 'react';
import {
  getCountryMaster,
  getViewerInfo,
  getLatestVenueNews,
  getVenueNewsAll,
  getAllFAQs,
} from '../../api';

import moment from 'moment';

const AppContext = createContext();

const m = moment();
m.add(-8, 'days');
m.startOf('day');
const periodStart = m.format('YYYY-MM-DD');
m.add(6, 'days');
m.startOf('day');
const periodEnd = m.format('YYYY-MM-DD');

const initialState = {
  viewer: null,
  countries: [],
  header: false,
  latest_news: null,
  news: [],
  faqs: [],
  dashboard_period: {
    year: (new Date()).getFullYear(),
    month: (new Date()).getMonth() + 1,
  },
  chart_period: {
    from: periodStart,
    to: periodEnd,
    year: 0,
    month: 0,
    category: '7days',
  },
  chart_view: {
    per_page: 10,
    sort_by: 'default',
    sort_order: 'asc',
  },
};

function reducer(state, action) {
  console.log(state, action);
  let newState = null;
  switch (action.type) {
    case 'set_dashboard_period': {
      newState = {
        ...state,
        dashboard_period: action.dashboard_period,
      };
    }
      break;
    case 'set_chart_period': {
      newState = {
        ...state,
        chart_period: {
          ...state.chart_period,
          ...action.chart_period,
        },
      };
    }
      break;
    case 'set_chart_view': {
      newState = {
        ...state,
        chart_view: {
          ...action.chart_view
        }
      };
    }
      break;
    case 'set_countries': {
      newState = {
        ...state,
        countries: action.countries.filter((c) => c.areas.length),
      };
    }
      break;
    case 'set_viewer_info': {
      newState = {
        ...state,
        viewer: action.viewer,
      };
    }
      break;
    case 'set_header': {
      newState = {
        ...state,
        header: action.header,
      };
    }
      break;
    case 'set_latest_news': {
      newState = {
        ...state,
        latest_news: action.latest_news,
      };
    }
      break;
    case 'set_news': {
      newState = {
        ...state,
        news: action.news,
      };
    }
      break;
    case 'set_faqs': {
      newState = {
        ...state,
        faqs: action.faqs,
      };
    }
      break;
    default:
      throw new Error(`${action.type} is not defined.`);
  }
  //updateHeaderState(newState);
  return newState;
}

function updateHeaderState(state) {
  if (!state.header) {
    document.getElementsByTagName('body')[0].classList.remove('header');
  } else {
    document.getElementsByTagName('body')[0].classList.add('header');
  }
}

export const AppContextProvider = ({api, children}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    (async () => {
      window.incrementLoading();
      try {
        await Promise.all([
          (async () => {
            const countries = await getCountryMaster();
            dispatch({
              type: 'set_countries',
              countries,
            });
          })(),
          (async () => {
            const viewer = await getViewerInfo();
            dispatch({
              type: 'set_viewer_info',
              viewer,
            });
          })(),
          (async () => {
            const latest_news = await getLatestVenueNews();
            dispatch({
              type: 'set_latest_news',
              latest_news,
            });
          })(),
        ]);
      } catch (e) {
        console.error(e);
      }
      window.decrementLoading();
    })();
  }, []);

  const showHeader = (forceHeaderLink = false) => {
    /*
    dispatch({
      type: "set_header",
      header: true,
    });
    */
    window.forceHeaderLink = forceHeaderLink;
    let classList = document.getElementsByTagName('body')[0].classList;
    classList.add('header');
    classList.remove('registration-wizard');

    if (forceHeaderLink) {
      classList.add('header-link');
    } else {
      classList.remove('header-link');
    }
  };

  const hideHeader = () => {
    /*
    dispatch({
      type: "set_header",
      header: false,
    });
    */
    window.forceHeaderLink = false;
    let classList = document.getElementsByTagName('body')[0].classList;
    classList.remove('header');
    classList.remove('header-link');
    classList.remove('registration-wizard');
  };

  const refreshLatestNews = async () => {
    try {
      const latest_news = await getLatestVenueNews();
      dispatch({
        type: 'set_latest_news',
        latest_news,
      });
    } catch (e) {
      console.error(e);
    }
  };

  const refreshNews = async () => {
    try {
      const news = await getVenueNewsAll();

      let expandedNewsIDSet = new Set(
          (state.news || []).filter(n => n.expanded).map(n => n.venuenews_id));
      if (!state.news.length && news.length) {
        expandedNewsIDSet.add(news[0].venuenews_id);
      }

      news.forEach(n => {
        n.expanded = false;
        if (expandedNewsIDSet.has(n.venuenews_id)) {
          n.expanded = true;
        }

        if (typeof n.description_en == 'object' && n.description_en.ops &&
            n.description_en.ops.length) {
          let op = n.description_en.ops[n.description_en.ops.length - 1];
          if (op.insert && Object.keys(op).length == 1) {
            op.insert = op.insert.replace(/\n+$/, '');
          }
        }

        n.links = [];
        if (n.link) {
          n.links.push({
            url: n.link,
            label: n.link_label || n.link,
          });
        }
        if (n.link2) {
          n.links.push({
            url: n.link2,
            label: n.link2_label || n.link2,
          });
        }
        if (n.link3) {
          n.links.push({
            url: n.link3,
            label: n.link3_label || n.link3,
          });
        }
      });

      dispatch({
        type: 'set_news',
        news,
      });
    } catch (e) {
      console.error(e);
    }
  };

  const toggleNewsExpand = (venuenews_id) => {
    state.news.some(n => {
      if (n.venuenews_id == venuenews_id) {
        n.expanded = !n.expanded;
        return true;
      }
      return false;
    });
    dispatch({
      type: 'set_news',
      news: state.news,
    });
  };

  const refreshFAQs = async () => {
    try {
      const faqs = await getAllFAQs();
      faqs.forEach(f => {
        f.category_values = new Set(f.categories.map(c => c.name));
        f.search = f.question_en.toLowerCase() + ' ' +
            f.answer_en.toLowerCase();
      });
      dispatch({
        type: 'set_faqs',
        faqs,
      });
    } catch (e) {
      console.error(e);
    }
  };

  const value = {
    state,
    dispatch,
    showHeader,
    hideHeader,
    refreshLatestNews,
    refreshNews,
    toggleNewsExpand,
    refreshFAQs,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => {
  return useContext(AppContext);
};

export default AppContext;
